import React from "react";
import image from "../images/Camp/Copertina.png";


import Titolo from "../commons/Titolo";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";


import Space from "../commons/Space";
import SpaceL from "../commons/SpaceL";

import insta from "../icone/icons8-instagram-48.png";
import facebook from "../icone/icons8-facebook-48.png";

import "../styles/CorsiNuoto.css";
import "../styles/Estivi.css";

function CampEstivo() {
    const volantino = "/documents/Camp/Volantino_IlCignoSummerCamp.pdf";
    const regolamento = "/documents/Camp/Regolamento_IlCignoSummerCamp26.pdf";
    return (

        <div>
            <ScrollToTopOnMount />
            <Titolo title={"Summer Camp"} backgroundImage={image} />

            <div style={{ padding: "0 1em 1em 1em" }}>
                <SpaceL />

                {/* INFO BASE */}
                <div className="text-center">
                    <h1 style={{ color: "#EC635B", fontFamily: "Wedges" }}>Il Cigno Summer Camp</h1>
                    <h4>8 giugno - 24 luglio</h4>
                    <SpaceL/>
                    <h3>Dal lunedì al venerdì</h3>
                    <h3>Ore 8 - 17</h3>
                    <h3>Per bambini dai 5 agli 11 anni</h3>
                </div>
                <SpaceL />

                {/* DOWNLOAD */}
                <div className="text-center">

                    <div style={{ marginTop: "1em" }}>
                        <a
                            href={volantino}
                            download
                            className="btn"
                            style={{
                                margin: "0.5em",
                                backgroundColor: "#F5A648",
                                borderColor: "#F5A648",
                                color: "white"
                            }}
                        >
                            Scarica Volantino
                        </a>

                        <a
                            href={regolamento}
                            download
                            className="btn"
                            style={{
                                margin: "0.5em",
                                backgroundColor: "#F5A648",
                                borderColor: "#F5A648",
                                color: "white"
                            }}
                        >
                            Scarica Regolamento
                        </a>
                    </div>
                </div>


                {/*/!* ISCRIZIONE *!/*/}
                {/*<div className="text-center">*/}
                {/*    <h5 style={{ marginTop: "1em" }}>*/}
                {/*        Compila la domanda di iscrizione online cliccando qui:*/}
                {/*    </h5>*/}
                
                {/*    <a*/}
                {/*        href="https://docs.google.com/forms/d/e/1FAIpQLScoaalAZMmGzBrrewbqEw8I0S2QB5_1heL-y0_pVmATTng3pw/viewform?usp=header"*/}
                {/*        target="_blank"*/}
                {/*        rel="noreferrer"*/}
                {/*        className="btn btn-success"*/}
                {/*        style={{*/}
                {/*            margin: "0.5em",*/}
                {/*            backgroundColor: "#4B8DA4",*/}
                {/*            borderColor: "#4B8DA4",*/}
                {/*            color: "white"*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        Vai al modulo di iscrizione*/}
                {/*    </a>*/}
                {/*</div>*/}

                <Space />
                {/* CTA ISCRIZIONE */}
                <div className="text-center">
                    <h2 style={{ color: "#EC635B" }}>Iscrizioni a partire da lunedì 10 maggio</h2>
                    <h3 >Posti a settimana limitati</h3>
                    <h1 style={{ color: "#EC635B" }}>TI ASPETTIAMO!!</h1>

                    <p>
                        tel: <a style={{ color: "grey" }} href="tel:022401006">02 2401 006</a>
                        <br />
                        e-mail: <a style={{ color: "grey" }} href="mailto:info@ilcignosport.it">info@ilcignosport.it</a>
                    </p>

                    <p>
                        Via Fiorani, 74<br />
                        20099 Sesto San Giovanni (MI)
                    </p>

                    {/* SOCIAL */}
                    <div>
                        <a href="https://www.instagram.com/centrosportivoilcigno/?hl=it" target="_blank" rel="noreferrer">
                            <img src={insta} alt="instagram" />
                        </a>
                        <a href="https://www.facebook.com/ilcignosport.it/?locale=it_IT" target="_blank" rel="noreferrer">
                            <img src={facebook} alt="facebook" />
                        </a>
                    </div>
                </div>




                <Space />
            </div>
        </div>
    );
}

export default CampEstivo;